import "./About.css";
import React from "react";
import { SocialIcon } from "react-social-icons";
import { Link } from "react-router-dom";

const About = () => {
  return (
    <div className="container">
      <div className="backhome__link">
        <Link to="/">Back To Home</Link>
      </div>
      <div className="about__left">
        <img className="about__profil" src="/images/Profil.jpg" alt="" />
        <div className="about__social">
          <SocialIcon url="https://www.linkedin.com/in/ibrahim-ta%C5%9Fk%C4%B1n-4816ba170/" />
          <SocialIcon url="https://www.hackerrank.com/taskin_ibrahim?hr_r=1" />
          <SocialIcon url="https://github.com/ibrahimTaskin" />
        </div>
      </div>
      <div className="about__right">
        <div className="about__box">
          <h3>Hello,I'm</h3>
          <h2>İBRAHIM TAŞKIN</h2>
        </div>
        <div className="about__box">
          <h2><span style={{color:"#bb2649"}}>I</span> always strive to achieve the highest standard possible. </h2>
          <h2>I <span style={{color:"green"}}>always</span> try to <span style={{color:"orange"}}>learn</span> and develop new things.</h2>
          <h2>Software Developer 🧑🏻‍💻</h2>
        </div>
        <div className="about__box">
          {" "}
          <p>
            In line with my education and experience, I had the opportunity to
            work with different people, to take part in a team and to learn how
            to produce together.
          </p>
        </div>
        <div className="about__box">
          {" "}
          <p>
            I am a planned worker who loves his job and cares about details. I
            care a lot about learning new things and improving my skills, and
            for this purpose, I think it is necessary to benefit from the
            teaching of human relations. That's why it's so important to me to
            exchange information with the people on my team.
          </p>
        </div>
        <div className="about__box">
          {" "}
          <p>
            Being aware of the fact that developing ideas keeps the mind, and
            therefore the body, constantly active, I think it is important to be
            creative both in business and in personal life.
          </p>
        </div>
        <div className="about__box">
          {" "}
          <p>
            I am always working and striving to do more. I always aim for the
            best with the philosophy that the success of a person is as much as
            his effort. Working with a company in this direction and with a
            vision is among my goals.
          </p>
        </div>
        <div className="about__box">
          {" "}
          <p>
            Working at LC WAIKIKI right now.
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
